export default __webpack_public_path__ + "static/media/logo_Enershare_Icon.d3ec46c3.svg";